import React from 'react';
import { Section } from './ui/Section';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';
export default function OldSolutionsSection() {
  const failures = ['te piden inventar desde cero', 'te dan demasiadas opciones', 'dependen de motivación', 'se rompen con un imprevisto', 'y cuando se rompen, tú te dices: «otra vez fallé»'];
  return <Section className="bg-white" data-id="element-240">
      <div className="text-center mb-12" data-id="element-241">
        <h2 className="font-heading text-3xl md:text-5xl text-slate-900 leading-tight uppercase tracking-wide" data-id="element-242">
          El planner no falló… <br className="hidden md:block" data-id="element-243" />
          <span className="text-slate-400" data-id="element-244">
            te dejó sola frente a la hoja en blanco.
          </span>
        </h2>
      </div>

      <div className="max-w-2xl mx-auto space-y-4 mb-12" data-id="element-245">
        {failures.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.2
      }} className="flex items-start p-4 bg-red-50/50 rounded-lg border border-red-100 group" data-id="element-246">
            <motion.div initial={{
          scale: 0
        }} whileInView={{
          scale: 1
        }} transition={{
          type: 'spring',
          stiffness: 200,
          delay: index * 0.2 + 0.1
        }} data-id="element-247">
              <X className="text-red-500 mr-4 mt-1 flex-shrink-0 group-hover:rotate-90 transition-transform duration-300" size={24} data-id="element-248" />
            </motion.div>
            <span className={`text-lg md:text-xl text-slate-500 decoration-slate-300 decoration-2 relative ${index === failures.length - 1 ? 'animate-shake' : ''}`} data-id="element-249">
              <span className="relative z-10 opacity-60" data-id="element-250">{item}</span>
              <motion.span initial={{
            width: 0
          }} whileInView={{
            width: '100%'
          }} transition={{
            delay: index * 0.2 + 0.3,
            duration: 0.4
          }} className="absolute top-1/2 left-0 h-0.5 bg-slate-400 -translate-y-1/2 z-20" data-id="element-251" />
            </span>
          </motion.div>)}
      </div>

      <div className="text-center" data-id="element-252">
        <motion.p initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} transition={{
        delay: 1.5,
        type: 'spring'
      }} className="text-2xl md:text-3xl font-heading text-slate-900 uppercase tracking-wide" data-id="element-253">
          Pero no fallaste tú.{' '}
          <span className="bg-brand-amber/20 text-brand-amber px-2 py-1 rounded animate-pulse" data-id="element-254">
            Falló el sistema.
          </span>
        </motion.p>
      </div>
    </Section>;
}